const dropDownUploadImg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g id="Ic_Dropdown">
        <path
          id="Vector 1"
          d="M10.8292 6.22361L8.44721 10.9875C8.26295 11.3561 7.73705 11.3561 7.55279 10.9875L5.17082 6.22361C5.0046 5.89116 5.24634 5.5 5.61803 5.5H10.382C10.7537 5.5 10.9954 5.89116 10.8292 6.22361Z"
          fill="#2D061B"
          stroke="#2D061B"
        />
      </g>
    </svg>
  );
};

export default dropDownUploadImg